import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Heading from '../../../../generic-components/Heading';
import Icon from '../../../../generic-components/Icon';
import RightArrowIcon from '../../../../assets/svg/arrow-right-v2.svg';
import SeparatorIcon from '../../../../assets/svg/separator.svg';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';
import { ACTION_MODAL_TYPES, ActionModal } from '../../../../DesignSystem/ActionModal';
import { VIEWS_MAP } from '../../../../router/constants';
import { useStore } from '../../../../store';
import { STYLES, TEXTS } from '../consts/consts';
import { useUpdateExistingInvoice } from '../hooks/useUpdateExistingInvoice';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../../DesignSystem/LiliCloseButton/CloseButton';

const {
  INVOICE_CREATION: { NAV_CHILDREN: componentStyles },
} = STYLES;

const {
  INVOICE_CREATION: { NAV_CHILDREN: componentTexts },
} = TEXTS;
const {
  INVOICE_CREATION: { DISCARD_POPUP: discardPopupTexts },
} = TEXTS;

interface IProps {
  isLoading: boolean;
}

export const CreationNavChildren = ({ isLoading }: IProps) => {
  const invoiceData = useStore((state) => state.invoiceData);
  const navigate = useNavigate();
  const setInvoiceDataToUpdate = useStore((state) => state.setInvoiceDataToUpdate);

  const { t } = useTranslation();
  const [showDiscard, setShowDiscard] = useState<boolean>(false);
  const localInvoiceServiceItems = useStore((state) => state.localInvoiceServiceItems);
  const setInvoiceItemsToUpdate = useStore((state) => state.setInvoiceItemsToUpdate);
  const setIsNeedToValidateItems = useStore((state) => state.setIsNeedToValidateItems);
  const clearLocalItemsStore = () => {
    setIsNeedToValidateItems(false);
    setInvoiceItemsToUpdate([]);
  };
  const {
    customer: { externalId },
  } = useStore((state) => state.summary);
  const { mutate: mutateUpdateInvoice, isLoading: isUpdateInvoiceData } = useUpdateExistingInvoice(
    () => {
      setShowDiscard(false);
      clearLocalItemsStore();
      navigate(`/${VIEWS_MAP.INVOICES}`);
    },
    () => {
      navigate(`/${VIEWS_MAP.INVOICES}`);
      clearLocalItemsStore();
    },
  );
  const attachItemsToInvoice = () => {
    if (localInvoiceServiceItems.length === 0) {
      navigate(`/${VIEWS_MAP.INVOICES}`);
      setShowDiscard(false);
      clearLocalItemsStore();
      return;
    }
    const invoiceDataToUpdate = { ...invoiceData };
    invoiceDataToUpdate.invoiceService.invoiceServiceItems = localInvoiceServiceItems.filter((p) => p.serviceItemId);
    mutateUpdateInvoice({
      customerId: externalId,
      invoicePayload: invoiceDataToUpdate,
      invoiceId: invoiceData?.externalId,
    });
  };

  const discardPopup = (
    <ActionModal
      title={t(discardPopupTexts.TITLE)}
      description={t(discardPopupTexts.DESCRIPTION)}
      mainButtonTitle={t(discardPopupTexts.OK_BUTTON)}
      cancelButtonTitle={t(discardPopupTexts.CANCEL_BUTTON)}
      onSubmit={attachItemsToInvoice}
      onCancel={() => setShowDiscard(false)}
      isLoading={isUpdateInvoiceData}
      modalType={ACTION_MODAL_TYPES.DESTRUCTIVE}
    />
  );
  const handleCloseInvoiceAdd = () => {
    setInvoiceDataToUpdate(null);
    setShowDiscard(true);
  };
  return (
    <div className={componentStyles.WRAPPER}>
      <div className={componentStyles.LEFT_CONTENT_WRAPPER}>
        {showDiscard && discardPopup}
        <CloseButton
          onClick={() => handleCloseInvoiceAdd()}
          id='invoiceCreationClose'
          size={CloseButtonSize.Medium}
          color={CloseButtonColor.Gray}
        />
        <Icon src={SeparatorIcon} className='' />

        <div className={componentStyles.BREAD_CRUMB_WRAPPER}>
          <Heading
            title={t(componentTexts.BREAD_CRUMB_MAIN_PATH)}
            className={componentStyles.BREAD_CRUMB_INACTIVE_PATH}
          />
          <Icon src={RightArrowIcon} className={componentStyles.BREAD_CRUMB_FLOW_ICON} />
          {isLoading ? (
            <Spinner spinnerColor={SpinnerColor.Blue} height='1rem' width='1rem' />
          ) : (
            <Heading
              id='invoiceNumber'
              title={`${t(componentTexts.BREAD_CRUMB_INVOICE_NUMBER_PREFIX)}${invoiceData?.invoiceNumber || ''}`}
              className={componentStyles.BREAD_CRUMB_ACTIVE_PATH}
            />
          )}
        </div>
      </div>
      <Heading title={t(componentTexts.TITLE)} className={componentStyles.NAV_TITLE} />
      <div className={componentStyles.PLACE_HOLDER_DIV} />
    </div>
  );
};
